export class VirtualPageView {
  event = 'virtualPageview';
  virtualPageURL: string;
  virtualPageTitle: string;
  userId: string;
}
